module.exports = __webpack_public_path__ + "img/swift-sport-banner.205b2551.svg";